import React, { useContext, useEffect, useRef, useState } from 'react';
import bell from '../src/assets/bell.mp3';
import { RoomContext } from './context/RoomContext';
import { SdkContext } from './context/SdkContext';
import {
	BsCameraVideo,
	BsChat,
	BsFillMicMuteFill,
	BsCameraVideoOffFill,
} from 'react-icons/bs';
import { BiMicrophone, BiDoorOpen } from 'react-icons/bi';
import { TbBellRingingFilled } from 'react-icons/tb';
import { LuMonitor } from 'react-icons/lu';
import { HiLockClosed, HiLockOpen } from 'react-icons/hi';
import { RiGroupFill } from 'react-icons/ri';

import sample from './assets/sample.mp4';

import Button from './ui/Button';
import Tab from './ui/Tab';
export default function VideoRoom() {
	const { roomInfo, setRoomInfo } = useContext(RoomContext);
	const sdk = useContext(SdkContext);
	const [showSidebar, setShowSidebar] = useState(false);

	const [videoDevices, setVideoDevices] = useState([]);
	const [audioDevices, setAudioDevices] = useState([]);
	const [userInfoArr, setUserInfoArr] = useState([]);
	const [screenShare, setScreenShare] = useState({});
	const [audioMutedUsers, setAudioMutedUsers] = useState({});
	const [videoMuteUsers, setVideoMuteUsers] = useState({});
	const [localAudioMute, setLocalAudioMute] = useState(false);
	const [localVideoMute, setLocalVideoMute] = useState(false);

	const handleLocalAudioMuteState = () => {
		setLocalAudioMute(!localAudioMute);
	};
	const handleLocalVideoMuteState = () => {
		setLocalVideoMute(!localVideoMute);
	};
	const audioRef = useRef();
	// audio mute
	const onOffSidebar = () => {
		setShowSidebar(false);
	};
	const handleAudioMute = session => {
		setAudioMutedUsers(prevState => ({ ...prevState, [session]: true }));
	};

	const handleAudioUnmute = session => {
		setAudioMutedUsers(prevState => ({ ...prevState, [session]: false }));
	};

	// video mute
	const handleVideoMute = session => {
		setVideoMuteUsers(prevState => ({ ...prevState, [session]: true }));
	};

	const handleVideoUnmute = session => {
		setVideoMuteUsers(prevState => ({ ...prevState, [session]: false }));
	};

	const mainContentWidth = showSidebar ? 'w-[80%]' : 'w-[100%]';
	const handleCameraSelect = async deviceId => {
		try {
			await sdk.setVideoDevice(deviceId).then(res => {});
		} catch (error) {
			console.error('Error setting video device:', error);
		}
	};
	const handleMicSelect = async deviceId => {
		try {
			await sdk.setAudioDevice(deviceId).then(res => {});
		} catch (error) {
			console.error('Error setting mic device:', error);
		}
	};

	const handleLeave = () => {
		sdk.leave(roomInfo.localSession);
		setRoomInfo({ ...roomInfo, hasEnteredRoom: false });
		window.location.reload();
	};
	const updateUserInfoArr = newData => {
		setUserInfoArr(prevUserInfoArr => [...prevUserInfoArr, newData]);
	};
	const updateScreenShareInfo = newData => {
		setScreenShare(prevScreenShareInfo => ({
			...prevScreenShareInfo,
			...newData,
		}));
	};
	useEffect(() => {
		async function publishLocalUser() {
			await sdk.getDeviceList().then(res => {
				setVideoDevices(res.videoinput);
				setAudioDevices(res.audioinput);
			});
			await sdk.publish(roomInfo.userId).then(res => {
				setRoomInfo({ ...roomInfo, session: res.session });
			});
			await sdk.publishList().then(async res => {
				if (res.list.length !== 0) {
					res.list.forEach(item => {
						updateUserInfoArr({
							session: item.session,
							userId: item.user_id,
						});
					});
				}
			});
			if (roomInfo.screen) {
				const screenListResult = await sdk.screenList();
				updateScreenShareInfo({
					session: screenListResult.session,
					userId: screenListResult.user_id,
				});
			}
		}
		try {
			publishLocalUser();
		} catch (error) {
			console.log(error);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		sdk.on('close', () => {
			console.log('close event');
		});
		sdk.on('event', async msg => {
			switch (msg.cmd) {
				case 'BROADCASTING_EVENT':
					try {
						updateUserInfoArr({
							session: msg.session,
							userId: msg.user_id,
						});
					} catch (error) {
						console.log(error);
					}
					break;
				case 'LEAVE_EVENT':
					setUserInfoArr(prev => {
						const filteredData = prev.filter(
							userInfo => userInfo.session !== msg.session,
						);
						return [...filteredData];
					});
					break;
				case 'SCREEN_SHARE_EVENT':
					audioRef.current.play();
					try {
						updateScreenShareInfo({
							session: msg.session,
							userId: msg.user_id,
							modal: true,
						});
					} catch (error) {
						console.log(error);
					}
					break;
				case 'SCREEN_UNSHARE_EVENT':
					try {
						updateScreenShareInfo({ show: false, userId: '' });
					} catch (error) {
						console.log(error);
					}
					break;
				case 'MUTE_EVENT':
					if (msg.track === 'audio') {
						handleAudioMute(msg.session);
					}
					if (msg.track === 'video') {
						handleVideoMute(msg.session);
					}
					break;
				case 'UNMUTE_EVENT':
					if (msg.track === 'audio') {
						handleAudioUnmute(msg.session);
					}
					if (msg.track === 'video') {
						handleVideoUnmute(msg.session);
					}
					break;
				default:
					break;
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	useEffect(() => {
		userInfoArr.map(async userInfo => {
			try {
				await sdk.subscribe(userInfo.session, userInfo.userId);
			} catch (error) {
				console.log(error);
			}
		});
	}, [userInfoArr]);
	return (
		<div className="flex max-w-[96rem] max-h-[54rem] m-auto ">
			<div className={mainContentWidth}>
				{/* --------------✨ 1. header ------------- */}
				<header className="xs:mt-10 xs:mb-10  sm:mt-20 sm:mb-20 px-10 ">
					<div className="flex items-center justify-between flex-wrap">
						<div className="flex justify-start xs:justify-center mb-2 ">
							<img
								alt="omnitalk-logo"
								src="https://user-images.githubusercontent.com/125844802/253941119-2010b608-42f2-45db-8a58-5f1c22e5fd05.svg"
								className="xs:w-20 sm:w-40 mt-auto mb-auto mr-8"
							></img>
							<div className="flex items-center bg-charcoal-trans text-xl w-fit p-3 rounded-md">
								<div className="flex items-center h-fit text-white">
									{roomInfo.secret ? (
										<HiLockClosed></HiLockClosed>
									) : (
										<HiLockOpen></HiLockOpen>
									)}
									<span className="xs:text-xs  sm:text-xl text-white ml-3">
										/ {roomInfo.subject}
									</span>
									<div className="border-l ml-3 mr-3 h-4 border-charcoal-50"></div>
								</div>
								<span className="xs:text-xs sm:text-xl text-white">
									{userInfoArr.length + 1} / 10
								</span>
							</div>
						</div>
						<div className="flex md:justify-end h-fit text-main  text-xl xs:justify-center ">
							<span className="xs:text-xs sm:text-xl mr-5">070-7663-0136</span>
							<span className="xs:text-xs sm:text-xl">pin number: 991000</span>
						</div>
					</div>
				</header>
				{/* ---------------------------✨ 1. screenshare -------------------------- */}
				<div
					className={`justify-center w-full h-full flex flex-col items-center gap-4 mb-5 ${
						screenShare.show ? '' : 'hidden'
					}`}
				>
					<div className="w-[80%] h-[100%] relative bg-charcoal-50 rounded-sm">
						<video
							className="object-contain w-full h-full"
							id="sharing"
						></video>
						{screenShare.isHost ? (
							<button
								type="button"
								className="absolute right-0 bottom-0 bg-black/50 text-white px-3 py-1"
								onClick={async () => {
									try {
										await sdk.screenUnshare();
										updateScreenShareInfo({ show: false });
									} catch (error) {
										console.log(error);
									}
								}}
							>
								공유 종료
							</button>
						) : (
							<button
								type="button"
								className="absolute right-0 bottom-0 bg-black/50 text-white px-3 py-1"
								onClick={async () => {
									console.log('취소');
									try {
										await sdk.unsubscribe(screenShare.session);
										updateScreenShareInfo({ show: false });
									} catch (error) {
										console.log(error);
									}
								}}
							>
								화면 공유 구독 취소
							</button>
						)}
					</div>
				</div>

				{/* --------------------------💥2. body ----------------------------- */}
				<audio src={bell} ref={audioRef}></audio>
				<div className="justify-center w-full h-fit flex flex-wrap content-center gap-4 ">
					{/* ----------------------2-1. 로컬 사용자--------------------------------- */}
					<div className="xs:w-[70%] sm:w-[30%]   bg-black  relative rounded-lg">
						<video
							id={roomInfo.userId}
							src={sample}
							autoPlay
							className="group peer  object-contain  hover:bg-black/60 rounded-lg"
						/>
						<div className="absolute right-3 bottom-3 z-10 ">
							<div className="flex gap-2">
								<BsCameraVideoOffFill
									className={` text-red-500 text-2xl ${
										localVideoMute ? '' : 'hidden'
									}`}
								/>
								<BsFillMicMuteFill
									className={` text-red-500 text-2xl ${
										localAudioMute ? '' : 'hidden'
									}`}
								/>
							</div>
						</div>
						<span className="text-sm absolute left-3 bottom-2 z-10  text-white bg-charcoal-trans-darker px-2 py-1 rounded-md">
							&nbsp;{roomInfo.userId} (me)
						</span>
					</div>
					{/* ----------------------2-1. 로컬 사용자--------------------------------- */}

					{userInfoArr.map((user, i) => {
						return (
							<div
								key={i}
								className="xs:w-[70%] sm:w-[30%]   bg-black  relative rounded-lg"
							>
								<video
									id={user.userId}
									autoPlay
									playsInline
									className={`group peer  absolute object-contain  hover:bg-black/60 rounded-lg ${
										videoMuteUsers[user.session] ? 'hidden' : ''
									}`}
								/>
								<div className="absolute right-3 bottom-3 z-10 ">
									<div className="flex gap-2">
										<BsCameraVideoOffFill
											className={` text-red-500 text-2xl ${
												videoMuteUsers[user.session] ? '' : 'hidden'
											}`}
										/>
										<BsFillMicMuteFill
											className={` text-red-500 text-2xl ${
												audioMutedUsers[user.session] ? '' : 'hidden'
											}`}
										/>
										{/* <BsFillMicMuteFill className=" text-red-500 text-2xl " /> */}
									</div>
								</div>
								<span className="text-sm absolute left-3 bottom-2 z-10  text-white bg-charcoal-trans-darker px-2 py-1 rounded-md">
									{user.userId}
								</span>
								<button
									type="button"
									className="w-24 h-12 bg-main text-white rounded-sm invisible peer-hover:visible mr-2"
								></button>

								<div className="absolute bottom-0 right-0 z-10">
									<button
										type="button"
										className="w-24 h-12 bg-main text-white rounded-sm invisible group-hover:visible mr-2"
									>
										btn
									</button>
									<button
										type="button"
										className="w-12 h-12 bg-main text-white rounded-sm invisible group-hover:visible mr-2"
									></button>
								</div>
							</div>
						);
					})}
				</div>
				{/* --------------------------💥2. body ----------------------------- */}

				{/* -------------------------- 👀 Modal  -------------------------- */}

				<div
					className={`min-w-screen h-screen animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 outline-none focus:outline-none bg-no-repeat bg-center bg-cover
           ${screenShare.modal ? '' : 'hidden'}`}
					id="modal-id"
				>
					<div className="absolute bg-black opacity-80 inset-0 z-0"></div>
					<div className="w-full  max-w-lg p-5 relative mx-auto my-auto rounded-xl shadow-lg  bg-white ">
						<div className="">
							<div className="text-center p-5 flex-auto justify-center items-center">
								<TbBellRingingFilled className="m-0 ml-auto mr-auto text-main text-3xl"></TbBellRingingFilled>
								<h2 className="text-xl font-bold py-4 ">
									{screenShare.isHost ? (
										<>
											{screenShare.userId}님<br></br> 화면 공유를 시작합니다.
											<p className="text-sm text-gray-500 px-8">
												공유를 취소하시려면 화면 공유 취소 버튼을 클릭하세요.
											</p>
										</>
									) : (
										<>
											{screenShare.userId}님이<br></br> 화면 공유를
											시작하였습니다.
											<p className="text-sm text-gray-500 px-8">
												화면 공유를 시청하시겠습니까?
											</p>
										</>
									)}
								</h2>
							</div>
							<div className="p-3  mt-2 text-center space-x-4 md:block">
								{screenShare.isHost ? (
									<>
										<button
											className="mb-2 md:mb-0 bg-orange-500 border border-orange-500 px-5 py-2 text-sm shadow-sm font-medium tracking-wider text-white rounded-full hover:shadow-lg hover:bg-orange-600"
											onClick={async () => {
												updateScreenShareInfo({ modal: false });
											}}
										>
											네
										</button>
									</>
								) : (
									<>
										<button
											className="mb-2 md:mb-0 bg-white px-5 py-2 text-sm shadow-sm font-medium tracking-wider border text-gray-600 rounded-full hover:shadow-lg hover:bg-gray-100"
											onClick={() => updateScreenShareInfo({ modal: false })}
										>
											나중에 할게요
										</button>
										<button
											className="mb-2 md:mb-0 bg-orange-500 border border-orange-500 px-5 py-2 text-sm shadow-sm font-medium tracking-wider text-white rounded-full hover:shadow-lg hover:bg-orange-600"
											onClick={async () => {
												try {
													await sdk.subscribe(screenShare.session, 'sharing');
													updateScreenShareInfo({ modal: false, show: true });
												} catch (error) {
													console.log(error);
												}
											}}
										>
											네
										</button>
									</>
								)}
							</div>
						</div>
					</div>
				</div>
				{/* -------------------------- 👀 Modal  -------------------------- */}

				{/* --------------------------🍋3. footer ---------------------------- */}
				<footer
					className={`mainContentWidth mt-20 ${
						showSidebar
							? 'absolute bottom-10 right-[50%]'
							: 'fixed bottom-20 left-1/2 transform -translate-x-1/2'
					}`}
				>
					<div className="flex gap-3 justify-center ">
						<Button
							label="카메라"
							icon={BsCameraVideo}
							videoDevices={videoDevices}
							onSelectOption={handleCameraSelect}
							type="video"
						/>
						<Button
							label="마이크"
							icon={BiMicrophone}
							audioDevices={audioDevices}
							onSelectOption={handleMicSelect}
							type="mic"
						/>
						<Button
							label="채팅"
							icon={BsChat}
							onClick={() => {
								setShowSidebar(!showSidebar);
							}}
						/>
						<Button
							label="공유"
							icon={LuMonitor}
							onClick={async () => {
								await sdk.screenShare('sharing');
								updateScreenShareInfo({
									show: true,
									userId: roomInfo.userId,
									isHost: true,
								});
							}}
						/>
						<Button
							label="참여자"
							icon={RiGroupFill}
							onClick={() => {
								setShowSidebar(!showSidebar);
							}}
						/>

						<Button
							label="나가기"
							icon={BiDoorOpen}
							onClick={() => handleLeave()}
						/>
					</div>
				</footer>

				{/* -------------🍋3. footer --------------- */}
			</div>
			{/* -show side bar- */}
			<Tab
				onOffSidebar={onOffSidebar}
				showSidebar={showSidebar}
				participants={userInfoArr}
				screenShare={screenShare}
				updateScreenShareInfo={updateScreenShareInfo}
				handleLocalAudioMuteState={handleLocalAudioMuteState}
				handleLocalVideoMuteState={handleLocalVideoMuteState}
			></Tab>
			{/* -show side bar- */}
		</div>
	);
}
